module.exports = __webpack_public_path__ + "img/gamifinna-like.9a9e9415.png";